"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SKILLS_HASH = void 0;
exports.GET_SKILLS_HASH = `
  {
    skills
  }
`;
//# sourceMappingURL=skills-queries.js.map